import { defineStore } from "pinia";


export const useCustomerItemsStore = defineStore("customerItemsStore", () => {

 

    async function getCustomerItemsPaginate(filter){
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/paginate`,{
            method: 'GET',
            use: 'admin',
            params:{
              ...filter
            }
           })
           
          return {
              success: true,
              data: data?.data,
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function deleteItemsAdmin(id) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/adi/admin/delete/${id}`,{
            method: 'DELETE',    
            use: 'admin'  
          })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function updateItemsAdmin(items) {
        try {

          const data = await useNuxtApp().$apiAuth(`/api/ad/admin/update`,{
            method: 'PUT',
            body:{
              ...items
            },
            use: 'admin'
           })
                
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
       async function getFilterData(items) {
        try {

          const {data} = await useNuxtApp().$apiAxios.get(`/api/ad/filter/data`,{
            params:{
              ...items
            } 
           })

                
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function getCustomerItemsPaginatePublic(filter){
        try {
          const {data} = await useNuxtApp().$apiAxios.get(`/api/ad/list/public/paginate`,{

            params:{
              ...filter,
             customer_id: '' 
            }
           })
                   
          return {
              success: true,
              data: data?.data,
            };
          
        } catch (error) {
     
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }

       async function getLawyerItemsPublic(filter){
        try {
          const { data } = await useNuxtApp().$apiAxios.get(`/api/ad/list/lawyer/public/paginate`,{

            params:{
              ...filter,
             customer_id: '' 
            }
           })
                   
          return {
              success: true,
              data: data?.data,
            };
          
        } catch (error) {
    
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getItemsCategoriesPaginatePublic(filter){
        try {
          const data = await useNuxtApp().$api(`/api/ad/list/public/categories/paginate`,{
            method: 'GET',
            params:{
              ...filter
            }
           })
          
           
          return {
              success: true,
              data: data?.data,
            };
          
        } catch (error) {
     
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }
      async function getCustomerItemsDetails(filter){
        try {
          const {data} = await useNuxtApp().$apiAxios.get(`/api/ad/list/public/details`,{
            params:{
              ...filter
            }
           })
          
           
          return {
              success: true,
              data: data?.data,
            };
          
        } catch (error) {
     
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
          };
        }
      }

        async function syncViewsCount() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/count/view/sync`,{
            method: 'GET',    
            use: 'admin'  
          })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
       async function syncFollowersCount() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/ad/count/followers/sync`,{
            method: 'GET',    
            use: 'admin'  
          })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
    return {
        getCustomerItemsPaginate,
        deleteItemsAdmin,
        updateItemsAdmin,
        getFilterData,
        getCustomerItemsPaginatePublic,
        getItemsCategoriesPaginatePublic,
        getCustomerItemsDetails,
        syncViewsCount,
        syncFollowersCount,
        getLawyerItemsPublic
         
    }
})
